import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HOST,CONSECUTIVO_USUARIO,NUEVO_USUARIO_DANE,CAMBIAR_ESTADO_USUARIO, DESCARGAR_EXCEL_USUARIOS, CAMBIAR_ESTADO_USUARIO2 } from 'src/app/global';
import { nuevousuariodto } from 'src/app/modelos/usuarios/nuevousuariodto';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { RespuestaCuadrosSalidaChvDto } from 'src/app/modelos/cuadrossalida/RespuestaCuadrosSalidaChvDto';

@Injectable({
  providedIn: 'root'
})
export class UsuariosServiceService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

//obtener consecutivo usuarios
consecutivoUsuario():Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CONSECUTIVO_USUARIO;
  return this.http.get<any>(direccion, {'headers': header});
}
//Guardar usuario nuevo DANE
nuevoUsuarioDane(usuario:nuevousuariodto):Observable<Boolean>{
 let header = new HttpHeaders();
 let token = "Bearer " + localStorage.getItem('token');
 header = header.set('Content-Type','application/json').set('Authorization',token);
 let direccion = this.url + NUEVO_USUARIO_DANE;
 const body = usuario;
 return this.http.post<Boolean>(direccion,body, {'headers': header});
}
//cambiar estado usuario
cambiarEstadoUsuario(usuario:UsuarioI):Observable<Boolean>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CAMBIAR_ESTADO_USUARIO;
  const body = usuario;
  return this.http.post<Boolean>(direccion,body, {'headers': header});
}
//cambiar estado usuario
cambiarEstadoUsuario2(idUsuario:any, idEstado:any):Observable<Boolean>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CAMBIAR_ESTADO_USUARIO2 + idUsuario + "/" + idEstado;
  return this.http.get<Boolean>(direccion, {'headers': header});
}

//descargar excel de usuarios
descargarExcelUsuarios():Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + DESCARGAR_EXCEL_USUARIOS;
  return this.http.get<any>(direccion, {'headers': header});
}

}
